import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import client from "../api/client";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
    Box,
    Grid,
    Typography,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    Avatar,
    InputAdornment,
} from "@mui/material";

const bgColor = "custom.red";
const inputStyles = {
    "& .MuiInputBase-input": {
        color: "#fff",
        backgroundColor: "rgba(0,0,0,0.15)",
        borderRadius: 2,
    },
    "& .MuiInputLabel-root": {
        color: "#fff",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#fff",
    },
    "& .MuiInputAdornment-root": {
        color: "#fff",
    },
    "& .MuiInputBase-input::placeholder": {
        color: "#fff",
        opacity: 1,
        backgroundColor: "#fff", // Add this line
        WebkitBackgroundClip: "text", // Optional, for better compatibility
    },
};


export default function FreeChapterSection() {
    const [form, setForm] = useState({ firstName: "", lastName: "", email: "", phone: "", agree: false });
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);
        const { firstName, lastName, email, phone, agree } = form;
        if (!firstName || !lastName || !email || !phone || !agree) {
            setStatus("Please fill all fields and accept emails.");
            return;
        }
        setLoading(true);
        try {
            const res = await client.post('/free-chapter', {
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                email: email.trim(),
                phone: phone.trim(),
            });
            // Navigate to parental guide with state flag to trigger success & conditional component
            navigate('/happyus-ppkp', { state: { fromFreeChapter: true } });
        } catch (err) {
            setStatus("Could not send chapter. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ bgcolor: bgColor, py: 6 }}>
            <Grid container justifyContent="center">
                <Grid item xs={12} md={10} lg={8}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Box mb={2} display="flex" alignItems="center">
                                <Avatar
                                    src="/assets/hero-component-4.svg"
                                    sx={{ width: 56, height: 56, mr: 2 }}
                                    variant="square"
                                />
                                <Typography variant="h6" fontWeight="bold">
                                    Applauded by readers worldwide: <span style={{ fontWeight: 700 }}>(4.98)</span>
                                </Typography>
                            </Box>
                            <Typography
                                variant="h4"
                                
                                fontWeight={400}
                                gutterBottom
                            >
                                <strong>
                                    A FREE Chapter &amp; Tools From The CYJ-Positive Psychology Kids' Program - "My Family"
                                </strong>
                            </Typography>
                            <Typography
                                variant="body1"
                                
                                mb={2}
                            >
                                This free chapter-Family-is one of the most special parts of my Positive Psychology Kids Program. I created this chapter with so much love-to bring back the spirit of a truly connected family. It’s about slowing down, cherishing the little things, and turning ordinary moments into lasting memories.
                            </Typography>
                            <Typography
                                variant="body1"
                                
                                mb={3}
                            >
                                It’s designed to help you and your child rediscover what truly connects you beyond routines, roles, and responsibilities-to feel closer, more present, and more like home together.
                            </Typography>
                            <Box component="form" onSubmit={handleSubmit} noValidate>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="First Name"
                                            name="firstName"
                                            value={form.firstName}
                                            onChange={handleChange}
                                            variant="outlined"
                                            size="small"
                                            placeholder="First Name"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LockOutlinedIcon sx={{ mr: 1, color: "grey.600" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            bgColor="custom.yellow"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Last Name"
                                            name="lastName"
                                            value={form.lastName}
                                            onChange={handleChange}
                                            variant="outlined"
                                            size="small"
                                            placeholder="Last Name"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LockOutlinedIcon sx={{ mr: 1, color: "grey.600" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            // sx={inputStyles}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            label="Your Email Here"
                                            name="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            variant="outlined"
                                            size="small"
                                            type="email"
                                            placeholder="Your Email Here"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LockOutlinedIcon sx={{ mr: 1, color: "grey.600" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            // sx={inputStyles}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            label="Your Phone Number Here"
                                            name="phone"
                                            value={form.phone}
                                            onChange={handleChange}
                                            variant="outlined"
                                            size="small"
                                            type="tel"
                                            inputProps={{ maxLength: 15 }}
                                            placeholder="Phone Number"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LockOutlinedIcon sx={{ mr: 1, color: "grey.600" }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            // sx={inputStyles}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={form.agree}
                                                    onChange={handleChange}
                                                    name="agree"
                                                    color="primary"
                                                />
                                            }
                                            label={
                                                <Typography variant="body2">
                                                    Yes, I agree to receive emails from you
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {status && (
                                            <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: status.startsWith('Chapter sent') ? 'success.main' : 'error.main' }}>
                                                {status}
                                            </Typography>
                                        )}
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            fullWidth
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: 19,
                                                bgcolor: "custom.yellow",
                                                color: "#010101",
                                                "&:hover": { bgcolor: "custom.yellow" },
                                            }}
                                            disabled={loading || !form.firstName || !form.lastName || !form.email || !form.agree}
                                        >
                                            {loading ? 'Sending...' : 'Download FREE Chapter My Family Now'}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} display="flex" justifyContent="center">
                            <Box>
                                <img
                                    src="/assets/freebie-ebook-cyj-ppkp2.png"
                                    alt="Free Chapter"
                                    width={700}
                                    style={{
                                        borderRadius: 12,
                                        boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                                        maxWidth: "100%",
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
